import React from 'react';

const CardTitle = ({ id }) => {
  return (
    <header>
      <h1>Advice #{id}</h1>
    </header>
  );
};

export default CardTitle;
